export default __webpack_public_path__ + "static/academicons-e868b5055f010359924be7e663d518aa.svg";